import { DataService } from "@/services/data";
import { RouteObject } from "react-router-dom";

const PicklistsRoute: RouteObject = {
    path: "picklists",
    children: [
        {
            path: "agents",
            loader: async () => {
                const agents = await DataService.client.url(`/voice/calls/agents/`).get().json();
                return agents;
            }
        }
    ]
};

export default PicklistsRoute;
